<template lang="pug">
  modal(:title='$t("login.forgotPassword.title")' @closeModal='hideElement({ element: "forgotPasswordModal" })')
    form.login-container.m-top-2(@submit.prevent='sendEmail' novalidate)
      .column
        p.text-normal.dark-gray.m-bottom-5
          | {{ $t('login.forgotPassword.text') }}
        .form-group.m-bottom-1
          label.text-normal.bold
            | {{ $t('login.email') }}
          input.input-border.text-normal.dark-gray(
            type='email'
            v-model='email'
            :placeholder='$t("login.emailPlaceholder")'
            :class='{ error: showErrors && (!$v.email.required || !$v.email.emailRegex) }'
          )
      .errors-container.column.m-bottom-2
        span.error-desc(v-if='showErrors && !$v.email.emailRegex')
          | {{ $t('login.errors.incorrectEmail') }}
        span.error-desc(v-if='showErrors && !$v.email.required')
          | {{ $t('login.errors.missingEmail') }}
        .row.middle.width-100.red.bold(v-if='requestError')
          simple-svg.red-stroke-icon.m-right-1(:filepath='errorIcon' :width='"15px"' :height='"15px"')
          span.error-desc {{ $t(`login.forgotPassword.errors.${requestError}`) }}
      .row.space-between.middle.width-100
        a.blue.text-normal(@click='goToLogin')
          | < {{ $t('login.goBackToLogin') }}
        button.primary-button(type='submit' :disabled='sendingMail')
          | {{ $t('login.send') }}
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'
import { emailRegex } from '@/utils/validators'
import errorIcon from '@/assets/ic_info.svg'

import Modal from '../Modal'

export default {
  data () {
    return {
      errorIcon,
      email: '',
      showErrors: false,
      sendingMail: false,
      requestError: false
    }
  },
  validations: {
    email: { required, email, emailRegex }
  },
  computed: {
    ...mapState({
      props: state => state.behavior.forgotPasswordModal.props
    })
  },
  methods: {
    ...mapActions([
      'showElement',
      'hideElement',
      'login',
      'requestPasswordChange'
    ]),
    async sendEmail () {
      this.requestError = false
      if (this.$v.$invalid) {
        this.showErrors = true
      } else {
        this.sendingMail = true
        const successModalProps = {
          title: this.$t('login.mailSendedModal.title'),
          subtitle: this.$t('login.mailSendedModal.subtitle'),
          buttonText: this.$t('login.mailSendedModal.buttonText')
        }
        const errorCode = await this.requestPasswordChange({ mail: this.email, successModalProps })
        if (errorCode) this.requestError = errorCode
        this.sendingMail = false
      }
    },
    goToLogin() {
      this.hideElement({ element: 'forgotPasswordModal' })
    }
  },
  components: { Modal }
}
</script>
